import { fetchAuthSession, fetchUserAttributes, getCurrentUser } from "aws-amplify/auth";
import { getMyCompetitionPerson } from "./leaderboardApi";

function stringValue(value) {
  return String(value || "").trim();
}

export async function getCompetitionAuthProfile() {
  let user = null;
  let attrs = {};
  let payload = {};
  let person = null;
  let directorDefaultsError = "";

  try {
    user = await getCurrentUser();
  } catch {
    user = null;
  }

  try {
    attrs = await fetchUserAttributes();
  } catch {
    attrs = {};
  }

  try {
    const session = await fetchAuthSession();
    payload = session?.tokens?.idToken?.payload || session?.tokens?.accessToken?.payload || {};
  } catch {
    payload = {};
  }

  try {
    person = await getMyCompetitionPerson();
  } catch {
    person = null;
    directorDefaultsError = "Your default range could not be loaded. You can still choose a venue for this match.";
  }

  const userId = stringValue(person?.cognitoSub || attrs.sub || payload.sub || user?.userId || user?.username);
  if (!userId) {
    return null;
  }

  const memberships = Array.isArray(person?.memberships) ? person.memberships : [];
  const findMembership = (...systems) => {
    const expected = systems.map((item) => String(item || "").toLowerCase());
    const found = memberships.find((item) => expected.includes(String(item?.system || "").toLowerCase()));
    return stringValue(found?.memberId);
  };

  // Legacy remember-entry saves may precede canonical membership records.
  // Account edits clear both stores, so a cleared ID cannot reappear here.
  const nraMemberId = findMembership("nra") || stringValue(person?.registrationDefaults?.nraMemberId);
  const nraCompetitorId = findMembership("nra-competitor") || stringValue(person?.registrationDefaults?.bullseyeNraCompetitorId);

  return {
    userId,
    personId: stringValue(person?.personId),
    email: stringValue(person?.email || attrs.email || payload.email),
    displayName: stringValue(
      person?.displayName ||
        attrs.preferred_username ||
        attrs.name ||
        payload.preferred_username ||
        payload.name ||
        user?.username
    ),
    memberships,
    registrationDefaults: person?.registrationDefaults || {},
    directorDefaults: person?.directorDefaults || {},
    directorDefaultsError,
    nraMemberId,
    nraId: nraMemberId || nraCompetitorId || stringValue(attrs["custom:nraId"] || payload["custom:nraId"]),
    nraCompetitorId,
    uspsaId: findMembership("uspsa") || stringValue(attrs["custom:uspsaId"] || payload["custom:uspsaId"]),
  };
}
